import { ImageLoaderProps } from 'next/image';
import { cloudflare } from '../utils';

const imageHost = process.env.NEXT_PUBLIC_PRODUCTS_IMAGES_URL || '';

export function productsLoader(props: ImageLoaderProps) {
    return cloudflare({ ...props, imageHost });
}
